import { render, staticRenderFns } from "./ProuniEducation.vue?vue&type=template&id=0a575850&"
import script from "./ProuniEducation.vue?vue&type=script&lang=ts&"
export * from "./ProuniEducation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports